import { render } from "./EditShoppingOffer.vue?vue&type=template&id=5e62c88f"
import script from "./EditShoppingOffer.vue?vue&type=script&lang=js"
export * from "./EditShoppingOffer.vue?vue&type=script&lang=js"
script.render = render

export default script